<template lang="pug">
div
  el-card.card-container(shadow="hover")
    filtro-pvtn(
      @pesquisar="pesquisar",
      @limpar="limpar",
      :filtro="filtro",
      placeholder="Informe nº do processo, interessado ou CPF/CNPJ do interessado"
    )
  el-row.container.cards(type="flex")
      app-card-dashboard(title="VTN atrasado" :content="this.dadosCards.totalAtrasado || '0'" color="#F96168" :style="{'marginLeft': 0}" :marginTop="0")
      app-card-dashboard(title="VTN prestes a vencer" :content="this.dadosCards.totalVencer || '0'" color="#FAD36D" :style="{'marginLeft': 0}" :marginTop="0")
      app-card-dashboard(title="VTN em dia" :content="this.dadosCards.totalEmDia || '0'" color="#009F61" :style="{'marginLeft': 0}" :marginTop="0")
  el-card.card-container(shadow="hover")
    div#tableHeader
      h3(style="marginTop: 1%; marginLeft : 1%") Listagem
    table-generica(
      :colunas="colunas",
      :botoesAcao="botoesAcao",
      :dados='dados.content'
    )
    el-row.container-switch(type="flex" style="marginTop: 1%")
      app-paginacao(
        :total="totalProcessos"
        :pagina="pagina + 1",
        @changePage="changePage($event)"
      )
</template>

<script>
import { mapActions } from 'vuex'
import FiltroPvtn from '@/screens/analise/vtn/FiltroPvtn'
import TableGenerica from '@/components/TableGenerica'
import Util from '@/utils/utils'
import AppCardDashboard from '@/components/AppCardDashboard'
import AppPaginacao from '@/components/AppPaginacao'
import parametros from './constants/tipoParametros'

export default {

  components: {
    FiltroPvtn,
    TableGenerica,
    AppCardDashboard,
    AppPaginacao
  },

  data () {
    return {
      totalProcessos: 0,
      pagina: 0,
      dados: [],
      filtro: parametros.FILTRO_EMPTY,
      filtroProcessos: {
        simplificado: true,
        campoSimplificado: ''
      },
      colunas: [
        {
          prop: 'processo.numeroProcesso',
          label: 'Processo',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'processo.cpfCnpjInteressado',
          label: 'CPF/CNPJ do Interessado',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'processo.nomeRazaoSocialInteressado',
          label: 'Nome/Razão social do Interessado',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'formaPagamento.nome',
          label: 'Tipo de Pagamento',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'processo.tipo.nome',
          label: 'Tipo de Processo',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'proximoVencimento',
          label: 'Próximo vencimento',
          width: 'auto',
          formatter: Util.formatEmptyRow
        },
        {
          prop: 'status',
          label: 'Situação',
          width: 'auto',
          formatter: Util.formatEmptyRow
        }
      ],
      dadosCards: {}
    }
  },

  methods: {
    ...mapActions({
      getAllVtn: 'vtn/getAllVtn',
      findVtnByFilter: 'vtn/findVtnByFilter',
      getDadosCardsGestao: 'vtn/dadosCardsGestao'
    }),

    async limpar () {
      this.filtro = {
        simplificado: true,
        campoSimplificado: ''
      }
      this.dados = await this.findVtnByFilter(this.filtro)
    },

    async pesquisar () {
      this.dados = await this.findVtnByFilter({
        ...this.filtro,
        ordem: 'dataAlteracao',
        ordemDirecao: 'DESC',
        simplificado: true
      })
    },

    async changePage (newPage) {
      this.filtroProcessos.pagina = newPage - 1
      await this.findVtn()
    },

    botoesAcao (vtn) {
      const acoes = [
        {
          click: this.visualizar.bind(this, vtn),
          icon: 'visibility',
          title: 'Visualizar VTN',
          active: true
        },
        {
          click: this.gerenciar.bind(this, vtn),
          icon: 'edit',
          title: 'Gerenciar VTN',
          active: true
        }
      ]
      if (vtn.status !== 'Ativo') {
        return acoes.splice(0, 1)
      } else {
        return acoes
      }
    },

    visualizar (vtn) {
      this.$router.push({
        name: 'visualizar-vtn',
        params: {
          vtn: vtn,
          processo: vtn.processo
        }
      })
    },

    gerenciar (vtn) {
      this.$router.push({
        name: 'gerenciar-vtn',
        params: {
          vtn: vtn,
          processo: vtn.processo,
          isGerenciar: true
        }
      })
    },

    async findVtn () {
      this.dados = await this.findVtnByFilter(this.filtroProcessos)
      this.totalProcessos = this.dados.totalElements
      this.pagina = this.dados.number
    }
  },

  async created () {
    this.dadosCards = await this.getDadosCardsGestao()
    await this.findVtn()
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}

#tableHeader {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1%;
}

.container {
  display: flex;
  width: 64%;
  min-height: 100%;
  gap: 4%;
}

.container-switch {
  justify-content: center;
  gap: 2%;
  font-weight: bold;
  height: 10vh;
  align-items: center;
  margin-top: 3%;
}

@media screen and (min-width: 1820px){
  .container {
    width: 52%;
  }
}

.cards{
  margin: 0 auto;
  justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/GestaoVtn.vue